import { formatValidQueryParamUrlCommaSeparated } from "../utils/common";
import { emptySplitApi } from "./empty-split-api";
import {
  FormTemplatePDFInput,
  FormTemplatesFilters,
  FormTemplatesResponse,
} from "./types/form-templates.type";

const extendedFormTemplatesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPracticeFormTemplates: builder.query<
      FormTemplatesResponse,
      FormTemplatesFilters
    >({
      query: ({ practice, ...filters }) =>
        `form-templates/?practice=${practice}&${formatValidQueryParamUrlCommaSeparated(
          filters
        )}&limit=300`,
      providesTags: ["FormTemplates"],
    }),

    downloadTemplateForm: builder.mutation<Blob, FormTemplatePDFInput>({
      query({
        form_template,
        patient,
        template_data,
        appointment,
        sale,
        clinic,
      }) {
        return {
          url: `/form-templates/${form_template}/?${formatValidQueryParamUrlCommaSeparated(
            { patient, appointment, sale, clinic, template_data }
          )}`,
          method: "GET",
          headers: {
            Accept: "application/pdf",
          },
          responseHandler: async (response) => {
            const blob = await response.blob();
            return blob;
          },
          cache: "no-cache",
        };
      },
      invalidatesTags: [],
    }),
  }),
});

export const {
  useGetPracticeFormTemplatesQuery,
  useDownloadTemplateFormMutation,
} = extendedFormTemplatesApi;
